import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { adminRoleList } from 'src/models/GalenData/UserRole.model';

export const useCheckNavItemVisibility = () => {
  const {
    currentUser,
    userSettings: { userPermission },
  } = useRemoteBoundStore();

  const userType = currentUser?.currentRole?.role;

  const isShowNewExamPage = userPermission.create;

  const isShowResultsPage = userPermission.list;

  const isShowUsersPage = userType && adminRoleList.includes(userType);

  return {
    isShowNewExamPage,
    isShowResultsPage,
    isShowUsersPage,
  };
};
